import React, { useEffect, useState } from "react"
import { FPaquetesStyle } from "./styles"
import {
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
} from "@material-ui/core"
import ListItemText from "@material-ui/core/ListItemText"
import Checkbox from "@material-ui/core/Checkbox"
import TablaRegistro from "./TablaRegistro"
import useGetAPI from "../../../hooks/useGetAPI"
import useCatalogo from "../../../hooks/useCatalogos"
import { ToastMessage } from "../../../global/ToastMessage"
import { useDispatch, useSelector } from "react-redux"
import { closeModalHotelPaqueteTerrestre, obtenerHotelelesPaqueteTerrestre, crearHotelPaqueteTerrestre } from "../../../ducks/proveedorTerrestreDuck"
import AutoInputPaises from "./../AutoInputPais"
import AutoInputCuidades from "./../AutoInputCiudades"
import AltaHotel from "./AltaHotel"
import HeaderModal from "../../../global/headerModal"
import ModalBase from "../../../global/ModalBase"
import { offLoadAction, onLoadAnction } from "./../../../ducks/loadDuck"
const InitialValuePais = {
  IdPais: 0,
  Nombre: "",
  Codigo: "0",
}
const InitialValueCiudad = {
  IdCiudad: 0,
  Nombre: ""
}
const ITEM_HEIGHT = 48
const ITEM_PADDING_TOP = 8
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
}
const getIdServicios = (arrayTipo) => {
  return arrayTipo.map((item) => {
    return item.IdServicio;
  })
}
const useHotelesPaqueteMayorista = () => {
  const dispatch = useDispatch()
  const { paqueteSelect } = useSelector(store => store.proveedorTerrestre)
  useEffect(() => {
    dispatch(onLoadAnction({ message: "" }))
    dispatch(obtenerHotelelesPaqueteTerrestre({ idPaqueteTerrestre: paqueteSelect?.IdPaqueteProveedorTerrestre })).then(
      (Response) => {
        dispatch(offLoadAction())
      }
    )
  }, [dispatch, paqueteSelect?.IdPaqueteProveedorTerrestre])
}

const FPaquetesHoteles = () => {
  const { paqueteSelect, openHotelTerrestre, listaHoteletesTerrestre } = useSelector(store => store.proveedorTerrestre)
  const dispatch = useDispatch()
  const classes = FPaquetesStyle()
  const catServicios = useCatalogo("Servicio")
  const [IdHotel, setIdHotel] = useState(0)
  const [servicios, setServicios] = useState([])
  const [pais, setPais] = useState(InitialValuePais)
  const [ciudad, setCuidad] = useState(InitialValueCiudad)
  const catHoteles = useGetAPI(`Hotel/Source/${ciudad.IdCiudad}`)
  useHotelesPaqueteMayorista()

  const onGuardar = () => {
    if (IdHotel <= 0) {
      ToastMessage.fire({
        icon: "warning",
        title: "<strong>Atención</strong>",
        text: "¡Seleccione un hotel valido!",
      })
      return
    }
    if (listaHoteletesTerrestre.find(paqueteHotel => paqueteHotel.Hotel.IdHotel === IdHotel)) {
      ToastMessage.fire({
        icon: "info",
        title: "<strong>Atención</strong>",
        text: "El hotel ya fue asignado al paquete.",
      })
      return
    }
    let hotel = {
      idPaqueteTerrestre: paqueteSelect.IdPaqueteProveedorTerrestre,
      idHotel: IdHotel,
      suplemento: 0,
    }
    dispatch(onLoadAnction({ message: "" }))
    dispatch(crearHotelPaqueteTerrestre(hotel)).then((Response) => {
      if (Response.status === 500) {
        ToastMessage.fire({
          icon: "error",
          title: "Ha habido un problema de conexión con el servidor",
        })
        return
      }
      if (Response.status === 400) {
        ToastMessage.fire({
          icon: "error",
          title: "Ha habido un problema de conexión con el servidor",
        })
        return
      }
      LimpiarForm()
      dispatch(obtenerHotelelesPaqueteTerrestre({ idPaqueteTerrestre: paqueteSelect.IdPaqueteProveedorTerrestre })).then(Response => {
        dispatch(offLoadAction())
        ToastMessage.fire({
          icon: "success",
          title: "Exito en la operacion",
        })
      })
    })
  }
  const LimpiarForm = () => {
    setIdHotel(0)
    setServicios([])
    setPais(InitialValuePais)
    setCuidad(InitialValueCiudad)
  }
  const handleClose = () => {
    dispatch(closeModalHotelPaqueteTerrestre())
    LimpiarForm()
  }
  const handleSelecHotel = (event) => {
    setIdHotel(event.target.value);
  }
  const getDescripcion = (arrayTipo) => {
    return arrayTipo.map((item) => {
      return item.Descripcion;
    });
  }
  const handleChange = (event) => {
    setServicios(event.target.value);
  }

  return (
    <ModalBase classes={classes} open={openHotelTerrestre} onClose={handleClose}>
      <HeaderModal
        titulo={`Hoteles para el paqute ${paqueteSelect?.Nombre}`}
        handleClose={handleClose}
      />
      <Grid container className={classes.containerSpacing}>
        <Grid item xs={6}>
          <TablaRegistro />
        </Grid>
        <Grid item xs={6}>
          <Grid container className={classes.containerSpacing}>
            <Grid item xs={12}>
              <AutoInputPaises
                label="Pais de origen"
                name="pais"
                target={pais}
                setTarget={setPais}
              />
            </Grid>
            <Grid item xs={12}>
              <AutoInputCuidades
                label="Ciudad de origen"
                name="ciudad"
                target={ciudad}
                setTarget={setCuidad}
                CodigoPais={pais.Codigo}
              />
            </Grid>
            <Grid
              container
              direction="row"
              justifyContent="center"
              alignItems="center"
            >
              <Grid item xs={10}>
                <FormControl
                  variant="outlined"
                  className={classes.formControl}
                  disabled={ciudad.IdCiudad > 0 ? false : true}
                >
                  <InputLabel id="lTHotel">Hotel</InputLabel>
                  <Select
                    labelId="lTHotel"
                    id="SHotel"
                    name="hotel"
                    value={IdHotel}
                    onChange={handleSelecHotel}
                    label="Hotel"
                  >
                    <MenuItem value="0" disabled>
                      {"Seleccione una opción"}
                    </MenuItem>
                    {catHoteles.map((item, index) => (
                      <MenuItem key={item.IdHotel} value={item.IdHotel}>
                        {`${item.Descripcion}`}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={2}>
                <AltaHotel origen={ciudad} />
              </Grid>
            </Grid>
            {/* <Grid item xs={12}>
              <FormControl variant="outlined" className={classes.formControl}>
                <InputLabel id="demo-mutiple-checkbox-label">
                  Servicios
                </InputLabel>
                <Select
                  labelId="demo-mutiple-checkbox-label"
                  id="demo-mutiple-checkbox"
                  multiple
                  value={servicios}
                  onChange={handleChange}
                  input={<Select id="Select-multiple" />}
                  renderValue={(selected) =>
                    getDescripcion(selected).join(", ").toString()
                  }
                  MenuProps={MenuProps}
                >
                  {catServicios.map((item) => (
                    <MenuItem key={item.Descripcion} value={item}>
                      <Checkbox checked={servicios.indexOf(item) > -1} />
                      <ListItemText primary={item.Descripcion} />
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid> */}

            <Grid item xs={12} className={classes.modalBotonesCenter}>
              <Button
                onClick={onGuardar}
                variant="contained"
                color="primary"
                disabled={IdHotel > 0 ? false : true}
                className={classes.modalBoton}
              >
                Agregar
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Grid container className={classes.containerSpacing}>
        <Grid item xs={12} className={classes.modalBotonesCenter}>
          <Button
            onClick={handleClose}
            variant="contained"
            color="primary"
            className={classes.modalBoton}
          >
            Aplicar
          </Button>
        </Grid>
      </Grid>
    </ModalBase>
  )
}
export default FPaquetesHoteles
